import { render, staticRenderFns } from "./Home4Franja1.vue?vue&type=template&id=1cd2001d&scoped=true"
import script from "./Home4Franja1.vue?vue&type=script&lang=js"
export * from "./Home4Franja1.vue?vue&type=script&lang=js"
import style0 from "./Home4Franja1.vue?vue&type=style&index=0&id=1cd2001d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd2001d",
  null
  
)

export default component.exports